<template>
  <app-card
    id="conditions-card"
    class="p-6 flex flex-col"
    :status="project.conditions_evidence_approved_at ? 'complete' : 'incomplete'"
  >
    <div>
      <app-badge
        v-if="project.conditions_evidence_approved_at"
        type="positive"
        icon="check"
      >
        Approved
      </app-badge>
      <app-badge
        v-else-if="project.conditions_evidence_file_id"
        type="neutral"
        icon="check"
      >
        Awaiting Approval
      </app-badge>
      <app-badge
        v-else
        type="neutral"
        icon="important"
      >
        Required
      </app-badge>
      <h2 class="text-lg mb-1">
        {{ project.ref }} Annex B
      </h2>
    </div>
    <div
      class="text-grey-700 text-sm mb-6"
    >
      <div v-html="parseMarkdown(project.conditions)" />
    </div>
    <div 
      v-if="project.conditions_evidence_file_id"
      class="border-t pt-4 mt-auto flex items-center justify-end"
    >
      <icon-link
        :href="route('applications.files.download', { application: project.uuid, file: project.conditions_evidence_file_id }) + '?project=1'"
        class="ml-auto"
        icon="cheveron-down-circle"
        icon-placement="right"
        target="_blank"
      >
        Download
      </icon-link>
    </div>
    <div
      v-if="project.conditions && project.conditions_evidence_file_id && !project.conditions_evidence_approved_at"
      class="flex mt-4 -mx-6 -mb-6"
    >
      <button
        class="flex flex-1 items-center bg-positive-100 hover:bg-positive-200 py-4 font-bold text-positive-900 text-sm tracking-wide uppercase px-6 transition-all transition-normal focus:outline-none" 
        @click="sendConditionStatus('approve')"
      >
        <icon
          icon="check"
          class="w-5 h-5 icons-positive mr-2"
        />
        <span class="text-center flex-1">Approve</span>
      </button>
      <button
        class="flex flex-1 items-center bg-negative-100 hover:bg-negative-200 py-4 font-bold text-negative-900 text-sm tracking-wide uppercase px-6 transition-all transition-normal focus:outline-none" 
        @click="sendConditionStatus('reject')"
      >
        <icon
          icon="close-circle"
          class="w-5 h-5 icons-negative mr-2"
        />
        <span class="text-center flex-1">Reject</span>
      </button>
    </div>
  </app-card>
</template>

<script>
export default {
  name: 'FundingProjectConditionsCard',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  methods: {
    sendConditionStatus(status) {
      if(status === 'reject' && !confirm('Are you sure you want to reject this evidence? You will need to inform the lead company as to why it has been rejected.')) return
      return axios.patch(window.location, {
        status
      }).then((response)=> {
        return window.location.reload()
      }).catch(() => {
        return alert(`Sorry, we're unable to to process this request. Please try again later.`)
      })
    }
  }
}
</script>